(() => {
  const SAVE_SEL = '.snize-highlight-saving-text';
  const STOCK_SEL = '.snize-in-stock';
  const EMPTY_STOCK_RE = /^\s*in\s+stock\s*\(\s*(?:units?)?\s*\)\s*$/i;

  function parseMoney(text) {
    const match = String(text).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return match ? Number(match[1]) : NaN;
  }

  function percentFromLabel(card) {
    const label = card.querySelector('.snize-product-discount-label');
    const match = label && label.textContent.match(/(\d+)\s*%/);
    return match ? match[1] : '';
  }

  function percentFromPrices(card) {
    const price = card.querySelector('.snize-price');
    const compare = card.querySelector('.snize-discounted-price');
    if (!price || !compare) return '';

    const our = parseMoney(price.childNodes[0] && price.childNodes[0].textContent);
    const msrp = parseMoney(compare.textContent);
    if (!our || !msrp || msrp <= our) return '';

    return String(Math.round(((msrp - our) / msrp) * 100));
  }

  function annotateSavePercents(root) {
    root.querySelectorAll(SAVE_SEL).forEach((el) => {
      if (!el.textContent.trim() || el.dataset.savePercent) return;

      const card = el.closest('.snize-product');
      if (!card) return;

      const percent = percentFromLabel(card) || percentFromPrices(card);
      if (percent) el.dataset.savePercent = percent;
    });
  }

  function fixEmptyStock(root) {
    root.querySelectorAll(STOCK_SEL).forEach((el) => {
      const text = el.textContent.replace(/\s+/g, ' ').trim();
      if (!EMPTY_STOCK_RE.test(text)) return;
      el.textContent = 'In Stock';
    });
  }

  function refresh(root) {
    const scope = root && root.querySelectorAll ? root : document;
    annotateSavePercents(scope);
    fixEmptyStock(scope);
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      refresh(document);
    });
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length || mutation.type === 'characterData') {
        schedule();
        return;
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document));
  } else {
    refresh(document);
  }
})();
